import axios from "axios";
import {
  CounterApi,
  Configuration as CounterConfiguration,
} from "definitions/counter-api";
import {
  QueuesApi,
  ObjectStorageApi,
  Configuration as ExporterConfiguration,
} from "definitions/exporter";
import {
  GoatApi,
  Configuration as GoatConfiguration,
} from "definitions/goat-api";
import {
  ClientApi,
  SiteApi,
  Configuration as PoizonConfiguration,
  ExportApi,
  DewuApi,
} from "definitions/poizon-api";
import { Configuration as PoizonProductConfiguration } from "definitions/poizon-api-product";
import { PoizonApiApi } from "definitions/poizon-api-product";
import {
  PAYMENTApi,
  Configuration as BFFConfiguration,
  ORDERApi,
  CONSTRUCTORApi,
  SUBSCRIBEApi,
  PROMOTIONApi,
  AWARDADMINORDERApi,
  EXCHANGEApi,
  SERVICEMONITORINGApi,
} from "definitions/poizon-bff";
import {
  AUTHApi,
  CREDITSApi,
  USERApi,
  ApiTokenApi,
  Configuration as SSOConfiguration,
  ACCESSRIGHTApi,
  AWARDSApi,
  TELEGRAMApi,
  YANDEXApi,
} from "definitions/poizon-sso";
import {
  ProductApi,
  BrandApi,
  ProductSelectionApi,
  Configuration as ProductStorageConfiguration,
  CategoryApi,
} from "definitions/product-storage";
import {
  ShihuoAPIApi,
  Configuration as ShihuoConfiguration,
} from "definitions/shihuo-api";

import { axiosErrorHandler } from "./util";

const axiosClient = axios.create({});
axiosClient.interceptors.response.use(
  (r) => r,
  (er) => {
    axiosErrorHandler(er);
    return Promise.reject(er);
  },
);

// Без глобального error-toast: ошибки рисуем inline в плитке галереи
// (см. WatermarkOptionsForm → WatermarkGallery, статус ловит mapUploadError).
const uploadAxiosClient = axios.create({});

const priceAxiosClient = axios.create({});

const baseOptions = {
  headers: {
    "Cache-Control": "no-cache",
    "x-service-name": "poizon-api-frontend",
  },
};

const ApiSSOConfig = new SSOConfiguration({
  basePath: "/api/sso",
  baseOptions,
});
const ApiExporterConfig = new ExporterConfiguration({
  basePath: "/api/exporter",
  baseOptions,
});
const ApiBFFConfig = new BFFConfiguration({
  basePath: "/api/bff",
  baseOptions,
});
const ApiPoizonConfig = new PoizonConfiguration({
  basePath: "/api/dewu",
  baseOptions,
});
const ApiProductStorageConfig = new ProductStorageConfiguration({
  basePath: "/api/product-storage",
  baseOptions,
});
const ApiCounterConfig = new CounterConfiguration({
  basePath: "/api/counter",
  baseOptions,
});
const ApiPoizonProductConfig = new PoizonProductConfiguration({
  basePath: "/api/poizon-ru",
  baseOptions,
});
const ApiGoatConfig = new GoatConfiguration({
  basePath: "/api/goat",
  baseOptions,
});
const ApiShihuoConfig = new ShihuoConfiguration({
  basePath: "",
  baseOptions,
});

export const API = {
  productStorageApi: new ProductApi(
    ApiProductStorageConfig,
    undefined,
    axiosClient,
  ),
  brandsApi: new BrandApi(ApiProductStorageConfig, undefined, axiosClient),
  categoriesApi: new CategoryApi(
    ApiProductStorageConfig,
    undefined,
    axiosClient,
  ),
  productSelectionApi: new ProductSelectionApi(
    ApiProductStorageConfig,
    undefined,
    axiosClient,
  ),
  productSamplesApi: new ProductSelectionApi(
    ApiProductStorageConfig,
    undefined,
    axiosClient,
  ),
  authApi: new AUTHApi(ApiSSOConfig, undefined, axiosClient),
  accessRightApi: new ACCESSRIGHTApi(ApiSSOConfig, undefined, axiosClient),
  creditApi: new CREDITSApi(ApiSSOConfig, undefined, axiosClient),
  userApi: new USERApi(ApiSSOConfig, undefined, axiosClient),
  tokenApi: new ApiTokenApi(ApiSSOConfig, undefined, axiosClient),
  awardApi: new AWARDSApi(ApiSSOConfig, undefined, axiosClient),
  paymentApi: new PAYMENTApi(ApiBFFConfig, undefined, axiosClient),
  orderApi: new ORDERApi(ApiBFFConfig, undefined, axiosClient),
  poizonClientApi: new ClientApi(ApiPoizonConfig, undefined, axiosClient),
  poizonSiteApi: new SiteApi(ApiPoizonConfig, undefined, axiosClient),
  poizonPublicApi: new DewuApi(ApiPoizonConfig, undefined, axiosClient),
  exportApi: new ExportApi(ApiPoizonConfig, undefined, axiosClient),
  exporterQueueApi: new QueuesApi(ApiExporterConfig, undefined, axiosClient),
  objectStorageApi: new ObjectStorageApi(
    ApiExporterConfig,
    undefined,
    uploadAxiosClient,
  ),
  constructorApi: new CONSTRUCTORApi(ApiBFFConfig, undefined, axiosClient),
  subscribeApi: new SUBSCRIBEApi(ApiBFFConfig, undefined, axiosClient),
  telegramApi: new TELEGRAMApi(ApiSSOConfig, undefined, axiosClient),
  promotionApi: new PROMOTIONApi(ApiBFFConfig, undefined, axiosClient),
  yandexApi: new YANDEXApi(ApiSSOConfig, undefined, axiosClient),
  awardAdminApi: new AWARDADMINORDERApi(ApiBFFConfig, undefined, axiosClient),
  exchangeApi: new EXCHANGEApi(ApiBFFConfig, undefined, axiosClient),
  serviceMonitoringApi: new SERVICEMONITORINGApi(
    ApiBFFConfig,
    undefined,
    axiosClient,
  ),
  counterApi: new CounterApi(ApiCounterConfig, undefined, axiosClient),
  poizonProductApi: new PoizonApiApi(
    ApiPoizonProductConfig,
    undefined,
    priceAxiosClient,
  ),
  goatApi: new GoatApi(ApiGoatConfig, undefined, priceAxiosClient),
  shihuoApi: new ShihuoAPIApi(ApiShihuoConfig, undefined, priceAxiosClient),
};
